export enum FilterFields {
  PartnerId = 'PartnerID',
  CommunicationName = 'CommunicationName',
  GeoMarket = 'GeoMarket',
  Country = 'Country',
}
export const filterAreaFields: string[] = Object.values(FilterFields)
